import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeactivateGuard } from '../../shared/guards/candeactivate';
import { ConfirmInfoComponent } from './confirm-info/confirm-info.component';
import { DeliveryComponent } from './delivery.component';

const routes: Routes = [
  {
      path: '',
      component: DeliveryComponent,
      canDeactivate:[DeactivateGuard]
  },
  {
    path: 'confirm',
    component: ConfirmInfoComponent
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeliveryRoutingModule { }
